import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import AnnouncementForm from './AnnouncementForm'
import AnnouncementListing from './AnnouncementListing'

const Announcements = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <AnnouncementListing />
      </Route>
      <Route path={`${path}/new`}>
        <AnnouncementForm />
      </Route>
      <Route path={`${path}/edit/:announcementId`}>
        <AnnouncementForm />
      </Route>
    </Switch>
  )
}

export default Announcements
